import { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

interface UserLookupProps {
  value: string;
  onSubmit: (emaid: string) => void;
  hint?: string;
  resolving?: boolean;
  error?: string | null;
}

/** Both notification admin screens are per person, so both start by naming one. */
const UserLookup = ({ value, onSubmit, hint, resolving = false, error = null }: UserLookupProps) => {
  const [draft, setDraft] = useState(value);

  return (
    <form
      className="flex align-items-end gap-2 flex-wrap"
      onSubmit={(e) => {
        e.preventDefault();
        const trimmed = draft.trim();
        if (trimmed) onSubmit(trimmed);
      }}
    >
      <div className="flex flex-column gap-2">
        <label htmlFor="lookup-emaid" className="text-sm">eMAID or email</label>
        <InputText
          id="lookup-emaid"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="DE-COC-C… or someone@cocharge.de"
          className="w-24rem"
        />
      </div>
      <Button
        type="submit"
        label="Look up"
        icon="pi pi-search"
        loading={resolving}
        disabled={!draft.trim() || resolving}
      />
      {error && <span className="text-xs text-red-600 ml-2 mb-2" data-testid="lookup-error">{error}</span>}
      {!error && hint && <span className="text-xs text-color-secondary ml-2 mb-2">{hint}</span>}
    </form>
  );
};

export default UserLookup;
